import { TeamMemeber } from '@/lib/aboutPage';

const Team = () => {
  // 1. Performance: Memoized getInitials is overkill here, 
  // but we should add a safety check to prevent runtime crashes.
  const getInitials = (name) => {
    if (!name) return '??';
    return name
      .split(' ')
      .filter(Boolean) // Handles extra spaces between names
      .map((n) => n[0])
      .slice(0, 2) // Limit to 2 initials (e.g., JD)
      .join('')
      .toUpperCase();
  };

  return (
    <section 
      id="our-team"
      className="py-16 md:py-24 lg:py-32 px-6 bg-white"
      aria-labelledby="team-heading"
    >
      <div className="max-w-7xl mx-auto">

        {/* Header - Semantic Header for SEO */}
        <header className="text-center mb-12 md:mb-20">
          <div className="flex items-center justify-center gap-2 text-[#4F7AC2] font-bold mb-4">
            <span aria-hidden="true" className="text-xl">»</span>
            <span className="uppercase tracking-[0.2em] text-[10px] sm:text-xs">
               {TeamMemeber.subText}
            </span>
          </div>
          <h2 
            id="team-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#001D4A] leading-tight"
          >
            {TeamMemeber.title}
          </h2>
          
          <p className="max-w-3xl mx-auto text-base sm:text-lg text-gray-600 leading-relaxed mt-6">
            {TeamMemeber.description}
          </p>
        </header>

        {/* Team Grid - Semantic list structure */}
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 md:gap-x-12 gap-y-12 md:gap-y-16 list-none p-0">
          {TeamMemeber.Members.map((member, index) => (
            <li 
              key={member.id || index} 
              className="group flex flex-col items-start h-full"
            >
              {/* Member Article - Semantic for A11y */}
              <article className="flex flex-col items-start h-full w-full">
                
                {/* Top Row: Initials & Info */}
                <div className="flex items-center gap-4 mb-5">
                  {/* Initials Circle */}
                  <div 
                    className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center rounded-full bg-slate-50 border border-slate-100 transition-all duration-300 group-hover:border-[#4F7AC2] group-hover:bg-[#4F7AC2]/5 shadow-sm"
                    aria-hidden="true"
                  >
                    <span className="text-base sm:text-lg font-black text-[#4F7AC2] tracking-tighter transition-all duration-300 group-hover:scale-110">
                      {getInitials(member.name)}
                    </span>
                  </div>

                  {/* Name, Role & Email */}
                  <div className="flex flex-col min-w-0">
                    <h3 className="text-xl sm:text-2xl font-bold text-[#001D4A] transition-colors duration-300 group-hover:text-[#4F7AC2] leading-none mb-1.5 truncate">
                      {member.name}
                    </h3>
                    <p className="text-[#4F7AC2] font-bold text-[10px] sm:text-xs uppercase tracking-[0.15em] mb-2">
                      {member.role}
                    </p>
                    {/*<a 
                      href={`mailto:${member.email}`}
                      className="text-gray-500 text-xs sm:text-sm leading-relaxed hover:text-[#4F7AC2] transition-colors duration-300 underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#4F7AC2] rounded-sm"
                      aria-label={`Email ${member.name}`}
                    >
                      {member.email}
                    </a>*/}
                  </div>
                </div>

                {/* Bio Section - Refined readability */}
                <div className="relative pl-0 sm:pl-4 border-l-0 sm:border-l sm:border-slate-200 group-hover:border-[#4F7AC2]/40 transition-colors duration-500">
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed max-w-sm">
                    {member.bio}
                  </p>
                </div>
              </article>
            </li>
          ))}
        </ul>

      </div>
    </section>
  );
};

export default Team;
